import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LogoutIcon from '@mui/icons-material/Logout';
import DiscordIcon from '../DiscordIcon';
import SteamSignInButton from './SteamSignInButton';
import NavTab from './NavTab';

const DISCORD_INVITE_URL = 'https://discord.gg/axh6p5sdyN';

export default function AppHeader({ isAuthenticated, profile, signInWithSteam, signOut }) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      color="transparent"
      className="border-b border-slate-900/70 backdrop-blur-sm"
      sx={{
        background: 'linear-gradient(180deg, #050810 0%, #080d16 55%, #0c111c 100%)',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          mx: 'auto',
          width: '100%',
          maxWidth: '72rem',
          minHeight: { xs: 56, sm: 64 },
          px: { xs: 1.5, sm: 2 },
          py: { xs: 1, sm: 0.5 },
          gap: 1,
          flexWrap: 'nowrap',
        }}
      >
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.75, sm: 1.5 }} sx={{ minWidth: 0, flexShrink: 1 }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: { xs: 0, sm: 1 },
              color: 'inherit',
              textDecoration: 'none',
              flexShrink: 0,
            }}
          >
            <SportsEsportsIcon sx={{ color: '#818cf8', fontSize: { xs: 22, sm: 24 } }} />
            <Typography
              variant="h6"
              sx={{
                display: { xs: 'none', sm: 'block' },
                fontWeight: 700,
                color: '#f1f5f9',
                fontSize: '1.25rem',
                whiteSpace: 'nowrap',
              }}
            >
              GamingWithBros
            </Typography>
          </Box>
          {isAuthenticated && <NavTab to="/friends">Friends</NavTab>}
        </Stack>

        <Box sx={{ flexGrow: 1, minWidth: 8 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
          sx={{ flexShrink: 0 }}
        >
          {isAuthenticated && (
            <>
              <Avatar
                src={profile?.avatar_url}
                alt={profile?.display_name}
                sx={{ width: { xs: 32, sm: 36 }, height: { xs: 32, sm: 36 } }}
              >
                {(profile?.display_name || '?')[0]}
              </Avatar>
              <Typography
                variant="subtitle1"
                sx={{
                  display: { xs: 'none', md: 'block' },
                  fontWeight: 600,
                  color: '#f1f5f9',
                  maxWidth: 160,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {profile?.display_name}
              </Typography>
              <IconButton
                onClick={signOut}
                aria-label="Logout"
                color="inherit"
                sx={{ color: '#cbd5e1', display: { xs: 'inline-flex', lg: 'none' } }}
              >
                <LogoutIcon fontSize="small" />
              </IconButton>
              <Button
                onClick={signOut}
                color="inherit"
                startIcon={<LogoutIcon />}
                sx={{
                  display: { xs: 'none', lg: 'inline-flex' },
                  color: '#cbd5e1',
                  whiteSpace: 'nowrap',
                }}
              >
                Logout
              </Button>
            </>
          )}

          {!isAuthenticated && (
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <SteamSignInButton onClick={signInWithSteam} size="medium" />
            </Box>
          )}

          <IconButton
            component="a"
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Join Discord"
            sx={{
              display: { xs: 'inline-flex', sm: 'none' },
              color: '#a5b4fc',
              bgcolor: 'rgba(99, 102, 241, 0.15)',
              border: '1px solid rgba(129, 140, 248, 0.35)',
              '&:hover': { bgcolor: 'rgba(99, 102, 241, 0.25)' },
            }}
          >
            <DiscordIcon fontSize="small" />
          </IconButton>

          <Button
            variant="contained"
            color="primary"
            startIcon={<DiscordIcon />}
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: { xs: 'none', sm: 'inline-flex' },
              whiteSpace: 'nowrap',
              px: { sm: 2, md: 2.5 },
              fontSize: { sm: '0.8125rem', md: '0.875rem' },
            }}
          >
            Join Discord
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
